<template>
  <el-row>
    <el-col :span="24">
      <el-card>
        <div slot="header" class="flex justify-between">
          <span>{{ $t('viewAppInfo.title') }}</span>
          <div>
            <el-button v-if="viewAppInfo.index !== 2" type="primary" size="small" style="margin-right:10px;"
              @click="_openSelectAppInfoModel()">
              <i class="el-icon-search"></i>
              {{ $t('viewAppInfo.selectApp') }}
            </el-button>
            <el-button v-if="viewAppInfo.index !== 2 && viewAppInfo.needShowAddAppButton" type="primary" size="small"
              @click="_openAddAppInfoModel()">
              <i class="el-icon-plus"></i>
              {{ $t('viewAppInfo.addApp') }}
            </el-button>
          </div>
        </div>
        <div class="">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{ $t('viewAppInfo.appId') }}：
                </label>
                <label class="el-form-item__content">{{ viewAppInfo.appId }}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{ $t('viewAppInfo.appName') }}：
                </label>
                <label class="el-form-item__content">{{ viewAppInfo.name }}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{ $t('viewAppInfo.securityCode') }}：
                </label>
                <label class="el-form-item__content">{{ viewAppInfo.securityCode }}</label>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{ $t('viewAppInfo.whiteList') }}：
                </label>
                <label class="el-form-item__content">{{ viewAppInfo.whileListIp }}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{ $t('viewAppInfo.blackList') }}：
                </label>
                <label class="el-form-item__content">{{ viewAppInfo.blackListIp }}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-group">
                <label class="el-form-item__label">
                  {{ $t('viewAppInfo.remark') }}：
                </label>
                <label class="el-form-item__content">{{ viewAppInfo.remark }}</label>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-col>

    <choose-app ref="chooseApp" :emit-choose-app="'viewAppInfo'" :emit-load-data="'viewAppInfo'"></choose-app>

    <add-app ref="addApp" :call-back-listener="'viewAppInfo'" :call-back-function="'chooseApp'"></add-app>
  </el-row>
</template>

<script>
import ChooseApp from '@/components/dev/chooseApp/chooseApp'
import AddApp from '@/components/dev/addApp/addApp'

export default {
  name: 'ViewAppInfo',
  components: {
    ChooseApp,
    AddApp
  },
  props: {
    callBackListener: String,
    callBackFunction: String,
    needShowAddAppButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      viewAppInfo: {
        index: 0,
        flowComponent: 'App',
        appId: "",
        name: "",
        securityCode: "",
        whileListIp: "",
        blackListIp: "",
        remark: "",
        needShowAddAppButton: this.needShowAddAppButton
      }
    }
  },
  created() {
    this.$on('viewAppInfo', 'chooseApp', (app) => {
      this.$copyObject(app, this.viewAppInfo)
      this.$emit(this.callBackListener, this.callBackFunction, this.viewAppInfo)
    })
  },
  methods: {
    _openSelectAppInfoModel() {
      this.$refs.chooseApp.open()
    },
    _openAddAppInfoModel() {
      this.$refs.addApp.open()
    },
    onIndex(index) {
      this.viewAppInfo.index = index
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 20px;
}

.el-form-item__label {
  font-weight: bold;
}

.el-form-item__content {
  margin-left: 10px;
}
</style>